<template>
  <div class="loading-container">
    <svg class="loading-circular" viewBox="-10, -10, 50, 50">
      <path
        class="path"
        d="
            M 30 15
            L 28 17
            M 25.61 25.61
            A 15 15, 0, 0, 1, 15 30
            A 15 15, 0, 1, 1, 27.99 7.5
            L 15 15
            "
        :style="{ 'stroke-width': '4px', 'fill': 'rgba(0, 0, 0, 0)', 'stroke': strokeColor }"
      ></path>
    </svg>
  </div>
</template>
<script setup lang="ts">
  defineOptions({
    name: 'AppLoading'
  })

  // 支持接收颜色和线条宽度参数
  const props = defineProps({
    color: {
      type: String,
      default: 'rgba(0, 0, 0, 0.25)'
    }
  })

  // 计算最终使用的颜色
  const strokeColor = props.color
</script>
<style lang="stylus" scoped>
  .loading-container
      width 100%
      height 40px
      display: flex;
      align-items: center;
      justify-content: center;

  .loading-circular
      display inline
      width 40px
      height 40px
      animation loading-rotate 2s linear infinite
      .path
          animation: loading-dash 1.5s ease-in-out infinite;
          stroke-dasharray: 90, 150;
          stroke-dashoffset: 0;
          stroke-width: 2;
          // stroke: rgba(0, 0, 0, 0.25);
          stroke-linecap: round;

  @keyframes loading-rotate
      to {
          transform: rotate(360deg)
      }
  @keyframes loading-dash
      0% {
          stroke-dasharray: 1,200;
          stroke-dashoffset: 0
      }

      50% {
          stroke-dasharray: 90,150;
          stroke-dashoffset: -40px
      }

      to {
          stroke-dasharray: 90,150;
          stroke-dashoffset: -120px
      }
</style>
